import { graphql } from "../gql";

export const getAuditRulesQueryDoc = graphql(`
  query getAuditRules {
    auditRulesV2 {
      id
      name
      status
      selectCodeStr
      evaluateCodeStr
      ruleCodeTestResults
      createdAt
      createdBy
      __typename
    }
  }
`);
